export const Lazertag = {
  id: 1,
  seo_url: 'Lasertag-Kazan',
  title: 'Лазертаг',
  img1: 'lazertag/3.jpg',
  img2: 'lazertag/29.jpg',
  desc: 'Лазертаг — это командная игра для детей и взрослых, сочетающая спорт и развлечение, в которой игроки стараются попасть в противников лазерным лучом, зарабатывая очки.',
  detal: [
    { id: 1, title: 'Игра на выбивание' },
    { id: 2, title: 'Захвать контрольной точки' },
    { id: 3, title: 'Захвать флага' },
    { id: 4, title: 'Предатель' },
  ],
  link: 'https://spartakzn.ru/games/Lasertag-Kazan',
};

export const Gidraboll = {
  id: 2,
  seo_url: 'Gidroball-Kazan',
  title: 'Гидробол',
  img1: 'gidraboll/1.jpg',
  img2: 'gidraboll/2.jpg',
  desc: 'Гидробол — это динамичная командная игра, в которой игроки используют оружие, стреляющее безопасными гидрогелевыми шариками, чтобы поразить противников.',
  detal: [
    { id: 1, title: 'Игра на выбивание' },
    { id: 2, title: 'Захвать флага' },
    { id: 3, title: 'Оборона' },
  ],
  link: 'https://spartakzn.ru/games/Gidroball-Kazan',
};

export const Paintboll = {
  id: 3,
  seo_url: 'Paintball-Kazan',
  title: 'Пейнтбол',
  img1: 'pentbol/3.jpg',
  img2: 'pentbol/3.jpeg',
  desc: 'Пейнтбол - это игра для активных людей, которым приходится жестко контроллировать свои эмоции в повседневной жизни.',
  detal: [
    { id: 1, title: 'Уничтожить врага (быстро и технично)' },
    { id: 2, title: 'Прикрывать своих' },
    { id: 3, title: 'Не высовываться!' },
  ],
  link: 'https://spartakzn.ru/games/Paintball-Kazan',
};
